import script from "./setting.vue?vue&type=script&setup=true&lang=js"
export * from "./setting.vue?vue&type=script&setup=true&lang=js"

import "./setting.vue?vue&type=style&index=0&id=1e98f29e&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e98f29e"]])

export default __exports__